import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CashflowSubgroupModel, GenericResModel } from 'countable@model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HeaderNameModel } from '../model/workbook/header-name.model';
import { WbNoteModel } from '../model/workbook/wb-note.model';

@Injectable({
  providedIn: 'root'
})
export class WorkbookService {

  constructor(private http: HttpClient) { }

  updateSortAndRename(type: string, data: CashflowSubgroupModel[]): Observable<GenericResModel<string>> {
    const path = environment.apiV1 + '/cashflow-subgroup?action=' + type;
    return this.http.post<GenericResModel<string>>(path, data);
  }

  public getWbHeaderNote(engId: number, subModuleId: number): Observable<GenericResModel<string>> {
    return this.http.get<GenericResModel<string>>(environment.apiV1 + '/wb-header-note', {
      params: {engId: engId, subModuleId: subModuleId}
    });
  }

  public getWbLeftSide(engId: number): Observable<GenericResModel<string>> {
    return this.http.get<GenericResModel<string>>(environment.apiV1 + '/wb-left-side', {params: {engId: engId}});
  }

  public saveChangeWbHeaderName(headerNameModel: HeaderNameModel): Observable<GenericResModel<boolean>> {
    return this.http.post<GenericResModel<boolean>>(environment.apiV1 + '/wb-header-name-change', headerNameModel);
  }

  public saveWbNote(wbNoteModel: WbNoteModel): Observable<GenericResModel<boolean>> {
    return this.http.post<GenericResModel<boolean>>(environment.apiV1 + '/wb-note', wbNoteModel);
  }

  public saveOrderChange(data: string): Observable<GenericResModel<boolean>> {
    return this.http.post<GenericResModel<boolean>>(environment.apiV1 + '/wb-order-change', data);
  }

  public saveWbLeftSideNameChange(data: string): Observable<GenericResModel<boolean>> {
    return this.http.post<GenericResModel<boolean>>(environment.apiV1 + '/wb-left-side-name-change', data);
  }

  public saveWbCreateGroup(data: string): Observable<GenericResModel<boolean>> {
    return this.http.post<GenericResModel<boolean>>(environment.apiV1 + '/wb-create-group', data);
  }

  public saveWbAddItem(data: string): Observable<GenericResModel<boolean>> {
    return this.http.post<GenericResModel<boolean>>(environment.apiV1 + '/wb-add-item', data);
  }

  public deleteWbGroupItem(data: string): Observable<GenericResModel<boolean>> {
    return this.http.delete<GenericResModel<boolean>>(environment.apiV1 + '/wb-group-item', {params: {data: data}});
  }
}
